<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Comunicados</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Comunicados',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn type="button" color="primary" elevation="0" to="/comunicados/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col>
                                    <v-text-field dense id="name" label="Nome" v-model="datalist.filter.name"
                                        hide-details outlined></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-data-table :headers="datalist.headers" :items="dataset.data" :server-items-length="datalist.count"
                    :disable-sort="true" :loading="dataset.loading" no-data-text="Nenhum comunicado foi encontrado"
                    loading-text="Carregando dados..." class="app-table hover-table" hide-default-footer>

                    <template v-slot:[`item.created_at`]="{ item }">
                        {{ item.created_at | defaultDate }}
                    </template>

                    <template v-slot:[`item.actions`]="{ item }">
                        <v-row align="center">
                            <v-icon @click="viewItem(item)" size="large">
                                mdi-pencil-outline
                            </v-icon>
                        </v-row>
                    </template>
                </v-data-table>
                <v-divider></v-divider>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"

Vue.use(VueLodash, { lodash: _ })

export default {
    name: "EquipmentList",

    data: () => ({
        dataset: {
            data: [],
            loading: false
        },
        datalist: {
            filter: {
                name: "",
                email: "",
                is_active: 0
            },
            headers: [
                { text: "Título", value: "name" },
                { text: "Criado em", value: "created_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    created() {
        this.load();
    },

    methods: {
        async load() {

            let search = Object.fromEntries(Object.entries(this.datalist.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataset.loading = true;

            var limit = this.datalist.options.size;

            try {
                const result = await axios.get('/api/v1/announcements', { params: { page: this.datalist.options.page, limit: limit, search: search } });

                this.dataset.data = result.data.content.data;
                this.datalist.count = result.data.content.paging.total;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.loading = false;
            }

        },

        viewItem(item) {
            this.$router.push(`comunicados/${item.id}`);
        },

    },
};
</script>